import * as Analytics from 'analytics/Analytics';
import {ELN_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import {ShortcutDescription} from 'util/Keyboard';

/**
 * Track a keyboard shortcut usage for analytics.
 * @param description The shortcut description
 */
export function trackKeyboardShortcut(description: ShortcutDescription): void {
  Analytics.trackEvent(ELN_ANALYTICS_ACTIONS.USED_KEYBOARD_SHORTCUT, {
    shortcut: description.shortcut.normalizedShortcutText,
    description: description.description,
  });
}
